import React from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import './Modal.scss';
import Icon, {
  ICONS,
  ICON_TYPES,
} from '@/components/common/Elements/Icon/Icon';
import { useDialogPortal } from './useDialogPortal';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  titleTooltip?: string;
  /** Render brand top border (cfo blue) */
  brandTopBorder?: boolean;
  children?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  ariaLabel?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  titleTooltip,
  children,
  size = 'md',
  ariaLabel,
  brandTopBorder = true,
}) => {
  const portalEl = useDialogPortal({ isOpen, onClose });

  if (!isOpen) return null;

  const modalContent = (
    <div className="cc-modal-overlay" role="presentation" onMouseDown={onClose}>
      <div
        className={clsx(
          'cc-modal',
          `cc-modal--${size}`,
          brandTopBorder && 'tw-border-t-[5px] tw-border-t-cfo-blue-600'
        )}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel || title || 'Dialog'}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="cc-modal__header">
          {title && (
            <h3
              className="cc-modal__title tw-font-brandonTextMedium"
              title={titleTooltip || title}
            >
              {title}
            </h3>
          )}
          <button
            aria-label="Close"
            className="cc-modal__close"
            onClick={onClose}
          >
            <Icon icon={ICONS.close} iconType={ICON_TYPES.filled} />
          </button>
        </div>
        <div className="cc-modal__body">{children}</div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, portalEl);
};

export default Modal;
